// Single source of truth for what counts as a valid, customer-selectable tip preset.
// A preset is a percentage: a finite number greater than 0 and at most 100. (0% is not a
// preset — the "No tip" action represents the zero-tip choice.)
export function isValidTipPreset(value: any): boolean {
  return typeof value === 'number' && Number.isFinite(value) && value > 0 && value <= 100;
}

// Returns only the valid tip preset percentages from an arbitrary presets value.
export function sanitizeTipPresets(presets: any): number[] {
  return Array.isArray(presets) ? presets.filter(isValidTipPreset) : [];
}
